export function LoadingScreen({ message = "Loading..." }: { message?: string }) {
  return (
    <div className="loading-screen">
      <div className="loading-spinner" aria-hidden="true" />
      <div className="loading-message">{message}</div>
    </div>
  );
}
